/* RESPONSIBLE TEAM: team-inbox-experience */
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import type RouterService from '@ember/routing/router-service';
import { captureException } from 'embercom/lib/sentry';

export default class LinkWithText extends Helper {
  @service router!: RouterService;
  @service session!: Session;

  compute(params: [string, any | undefined, string]) {
    let [route, id, text] = params;

    if (
      this.session.workspace.isFeatureEnabled('spg-null-check-for-link-helper') &&
      (id === null || id === undefined)
    ) {
      captureException(new Error('link-with-text helper received null or undefined id'), {
        fingerprint: ['link-with-text-null-id'],
        extra: {
          route,
          text,
          currentRouteName: this.router.currentRouteName,
          currentURL: this.router.currentURL,
        },
        tags: {
          helper: 'link-with-text',
        },
      });
      return sanitizeHtml(text);
    }

    let href = this.router.urlFor(route, this.session.workspace.id, id);

    return sanitizeHtml(`<a class="hover:text-link  no-underline" href=${href}>${text}</a>`);
  }

  compute_with_href(href: string, text: string, underline?: boolean, openInNewTab?: boolean) {
    let targetAttr = openInNewTab ? ' target="_blank"' : '';
    return sanitizeHtml(
      `<a class="hover:text-link  ${!underline && 'no-underline'}"${targetAttr} href=${href}>${text}</a>`,
    );
  }
}
